import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=081757a4&scoped=true&"
import script from "./Ubicacion.vue?vue&type=script&lang=js&"
export * from "./Ubicacion.vue?vue&type=script&lang=js&"
import style0 from "./Ubicacion.vue?vue&type=style&index=0&id=081757a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081757a4",
  null
  
)

export default component.exports